import { fetchData } from '../api/api';
import { handleError } from '../context/errors/errorUtils';

// Создаём FormData для отправки
const createGameFormData = (data) => {
  const formData = new FormData();

  const allowedFields = ['gameId', 'step', 'userId', 'userText', 'completeGame', 'correctAnswer', 
                         'difficulty', 'round', 'phrasesCount', 'score', 'gameDuration', 'averagePhraseTime', 'gameLevel'];

  // Прикрепляем аудио, если есть
  if (data.audioBuffer) {
    formData.append('audio', new Blob([data.audioBuffer], { type: 'audio/wav' }), 'audio.wav');
  }

  Object.entries(data).forEach(([key, value]) => {
    if (allowedFields.includes(key) && value !== undefined) {
      formData.append(key, value);
    }
  });

  return formData;
};

// Основной метод отправки данных игры (аудио + шаг + завершение)
export const sendGameData = async (data = {}) => {
  try {
    const formData = createGameFormData(data);
    return await fetchData('/api/game', 'POST', formData);
  } catch (error) {
    handleError({
      code: 'GAME_DATA_FETCH_ERROR',
      error,
      context: {
        module: 'sendGameData',
        gameId: data.gameId,
        userId: data.userId,
        step: data.step, // номер шага (не раунда), на сервере не используется
      },
      showToUser: false,
    });
    throw error;
  }
};

// Первый запрос — получить фразы и создать или восстановить игру
export const fetchGame = async ({ userId, setData, setGameId, setLoading, setError, gameLevel }) => {
  try {
    //console.log(`Отправляем данные на сервер: ${userId}`);
    const response = await sendGameData({ userId, gameLevel });
    const { gameId, data: sentences } = response;
    if (!gameId || !sentences) {
      throw new Error('Некорректный ответ от сервера: отсутствует gameId или data');
    }
    setData?.(sentences);
    setGameId?.(gameId);
    return { gameId, sentences };
  } catch (error) {
    setError?.(error);
    throw error;
  } finally {
    setLoading?.(false);
  }
}; 

// Отправляем финальные данные на сервер 
export const sendGameScoresToServer = async ({ gameId, userId, stepId, completeGame = true, score, phrasesCount, round, difficulty, 		  gameDuration, averagePhraseTime }) => {
  try {
    const data = await sendGameData({ gameId, userId, step: stepId, completeGame, score, phrasesCount, round, difficulty, gameDuration, averagePhraseTime });
    return data; // вернём весь ответ, включая `stats`
  } catch (error) {
    handleError({
      code: 'FETCH_RESULT_FAILED',
      error,
      context: {
        module: 'fetchGame',
        gameId,
        userId
      },
      showToUser: false // для отладки
    });
    throw error;
  } 
};


